
import { Typography, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import { myVJBlack900, myVJRed100 } from "../../constants/brandingColors";
import { useLocalTranslationState } from "../../context/AppContext/AppContext";
import PrimaryLink from "../../components-redesign/StyledLinks/PrimaryLink";

const ChangeAccountLinkContainer = styled("div")({
  display: "flex",
  alignSelf: "flex-start",
  justifyContent: 'flex-start',
});

interface ChangeAccountProps {
  username: string;
  onClick: () => void;
  error?: boolean;
}

const ChangeAccount = ({
  username,
  onClick,
  error = false,
}: ChangeAccountProps) => {

  const { _translate } = useLocalTranslationState();

  return (
    <Grid
      container
      spacing={1}
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        flexWrap: {
          xs: 'wrap',
          sm: 'wrap',
          md: 'wrap',
          lg: 'wrap',
          xl: 'nowrap'
        }
      }}>
      <Grid sx={{
        display: 'flex',
        textWrap: 'nowrap',
        alignItems: 'center',
        gap: .5,
        minWidth: 0,
        width: {
          xs: '100%',
          sm: '100%',
          md: '100%',
          lg: '100%',
          xl: 'auto'
        }
      }} >
        <Typography variant="body2" fontWeight="600" color={myVJBlack900}>
          {_translate("Hello")}
        </Typography>
        <Typography variant="body2" fontWeight="400" color={error ? myVJRed100 : myVJBlack900} sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {username}
        </Typography>
      </Grid>
      <Grid sx={{
        flexShrink: 0,
        width: {
          xs: '100%',
          sm: '100%',
          md: '100%',
          lg: '100%',
          xl: 'auto'
        }
      }}>
        <ChangeAccountLinkContainer>
          <PrimaryLink
            text={_translate("Change")}
            onClick={onClick}
          />
        </ChangeAccountLinkContainer>
      </Grid>
    </Grid>
  );
};

export default ChangeAccount;